
import { fetchGetAuth } from "../utils/utils";
import { authActions } from "./auth-slice";

export const login = () => {
    return async (dispatch, getState) => {
        if (!window.config.disableLogin) {
            try {
                window.location.href = `${window.config.authApiUrl}/auth/eduidp?next=${window.location.origin}/ai`;
            }
            catch (e) {
                console.error("error", e);
            }
        }
    }
}

export const checkLogin = () => {
    return async (dispatch) => {
        try {
            let res = await fetch(`${window.config.authApiUrl}/auth/my`, {
                credentials: "include"
            })
            let data = await res.json();
            dispatch(authActions.init(data))
        }
        catch {
            dispatch(authActions.init({ isAuth: false }))
        }
    }
}

export const logout = () => {
    window.location.href = `${window.config.authApiUrl}/auth/logout?next=${window.location.href}`;
}

export const getUserDetails = () => {
    return async (dispatch) => {
        try {
            let resUserFilter = await fetchGetAuth(`${window.config.authApiUrl}/api/user/filter`);
            if (resUserFilter) {
                if (resUserFilter.schools)
                    resUserFilter.schools = resUserFilter.schools.filter((school, index) => index === resUserFilter.schools.findIndex(school2 => school2.id === school.id))
                dispatch(authActions.setUserDetails(resUserFilter))
            }
            else
                dispatch(authActions.setUserDetails({ genderId: 0 }))
        }
        catch {
            dispatch(authActions.init({ isAuth: false }))
        }
    }
}